import React from 'react';
import { Info, Check, Plus, ChevronLeft } from 'lucide-react';

export default function ModulesCatalog({ catalog, flow, onAdd, visible = true }) {
  return (
    <div className={`${visible ? 'flex' : 'hidden'} lg:flex flex-col border-r border-[#EEE9FB] bg-[#FAF8FF] p-4 md:p-5 overflow-y-auto zara-scroll`}>
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-[14.5px] md:text-[15px] font-bold text-[#1A1533]">Interview modules</h3>
        <button className="hidden lg:flex w-6 h-6 rounded-md hover:bg-[#EEE9FB] items-center justify-center text-[#6B6485]">
          <ChevronLeft size={14} />
        </button>
      </div>
      <p className="text-[12px] text-[#4A4463] leading-relaxed mb-4">
        Create a custom interview environment based on your exact requirements or choose from our recommended templates.
      </p>

      <div className="space-y-2">
        {catalog.map(({ id, label, Icon }) => {
          const alreadyAdded = id !== 'exercise' && flow.some((m) => m.type === id);
          return (
            <button
              key={id}
              onClick={() => onAdd(id)}
              className="module-card w-full flex items-center justify-between px-3 py-3 rounded-xl bg-white border border-[#ECE6FA] text-left"
            >
              <div className="flex items-center gap-2.5">
                <Icon size={16} className="text-[#5B4FE8]" />
                <span className="text-[13.5px] font-semibold text-[#1A1533]">{label}</span>
                <Info size={12} className="text-[#A39DB8]" />
              </div>
              {alreadyAdded ? <Check size={14} className="text-[#1F8A4E]" /> : <Plus size={14} className="text-[#5B4FE8]" />}
            </button>
          );
        })}
      </div>

      <div className="mt-5 p-4 rounded-xl border border-dashed border-[#C7BFF5] bg-[#F5F1FE] text-center">
        <span className="text-[12.5px] text-[#4A4463]">Not sure what to add? </span>
        <button className="text-[12.5px] text-[#5B4FE8] font-semibold hover:underline">Choose from templates</button>
      </div>
    </div>
  );
}
